import { useEffect, useState } from 'react';

import { Keys } from '../utils/types';

export const BREAKPOINT = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl',
} as const;

const BREAKPOINT_WIDTH = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

type Breakpoint = Keys<typeof BREAKPOINT>;

interface UseMediaQueryProps {
  breakpoint: Breakpoint;
  direction?: 'min' | 'max';
}

/**
 * @example
 * const isMd = useMediaQuery({ breakpoint: BREAKPOINT.md });
 */
export function useMediaQuery({ breakpoint, direction = 'min' }: UseMediaQueryProps) {
  const [value, setValue] = useState(false);

  useEffect(() => {
    function onChange(event: MediaQueryListEvent) {
      setValue(event.matches);
    }

    const result = matchMedia(`(${direction}-width: ${BREAKPOINT_WIDTH[`${breakpoint}`]}px)`);
    result.addEventListener('change', onChange);
    setValue(result.matches);

    return () => result.removeEventListener('change', onChange);
  }, [breakpoint, direction]);

  return value;
}
